import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout/layout.component';
import { LoginComponent } from './common/login/login.component';
import { ModulePageComponent } from './module-page/module-page.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SignInComponent } from './common/sign-in/sign-in.component';

export const routes: Routes = [
    // {path:'',component:LoginComponent},
    {path:'', component:SignInComponent},
   
    {path: 'module', component: LayoutComponent,
        children: [
            {path:'', component: ModulePageComponent}
        ]
    },
    {path:'privacy_policy', component:PrivacyPolicyComponent}
];
